import { render, staticRenderFns } from "./DailyNav.vue?vue&type=template&id=5bf42a1a"
import script from "./DailyNav.vue?vue&type=script&lang=js"
export * from "./DailyNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports